// extracted by mini-css-extract-plugin
module.exports = {"loadingBG":"style_loadingBG__12DHw","active":"style_active__1olL1","spinnerWrap":"style_spinnerWrap__2h_n3"};